// extracted by mini-css-extract-plugin
export default {"topFiltersItem__wide":"styles_top-filters-item__wide__W4tIg"};